<template>
    <portal to="modals">
        <Modal name="podcast-episodes-editor" no-max-width @closed="close">
            <template #content>
                <div class="podcast-episodes">
                    <div class="podcast-episodes__episodes">
                        <ul v-if="episodes.length" class="podcast-episodes__list">
                            <li
                                v-for="episode in episodes"
                                :key="episode.id"
                                class="podcast-episode-card"
                                :class="{
                                    unselected: selectedEpisode && selectedEpisode !== episode.id,
                                }"
                                @click="selectEpisode(episode.id)"
                            >
                                <span
                                    :title="episode.description"
                                    class="podcast-episode-card__title"
                                >
                                    {{ episode.description }}
                                </span>
                            </li>
                        </ul>
                        <div v-else class="podcast-episodes__empty">
                            <div>{{ $t('podcasts.episodes.empty') }}</div>
                            <button
                                v-if="!showForm"
                                class="button"
                                type="button"
                                @click="showForm = true"
                            >
                                {{ $t('podcasts.episodes.addEpisode') }}
                            </button>
                        </div>
                        <div v-if="canLoadMore" class="podcast-episodes__loadmore">
                            <button class="button" type="button" @click="loadmore">
                                {{ $t('misc.loadmore') }}
                            </button>
                        </div>
                    </div>
                    <div class="podcast-episodes__detail">
                        <PodcastEpisodeForm
                            v-if="showForm || selectedEpisode"
                            :id="selectedEpisode"
                            :podcast="podcast.id"
                            @update="onEpisodeAdded"
                        />
                        <div v-else class="podcast-episodes__empty">
                            <div>{{ $t('podcasts.episodes.notSelected') }}</div>
                            <button
                                class="button button--medium"
                                type="button"
                                @click="showForm = true"
                            >
                                {{ $t('podcasts.episodes.addEpisode') }}
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>
    </portal>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import PodcastEpisodeForm from '../PodcastEpisodeForm/PodcastEpisodeForm';

export default {
    name: 'PodcastEpisodesEditor',
    components: {
        Modal,
        PodcastEpisodeForm,
    },
    props: {
        podcast: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            episodes: [],
            episodesCount: 0,
            pageSize: 20,
            page: 1,
            showForm: false,
            selectedEpisode: undefined,
        };
    },
    computed: {
        canLoadMore() {
            return this.pageSize * this.page < this.episodesCount;
        },
    },
    watch: {
        page: 'fetchEpisodes',
    },
    created() {
        this.fetchEpisodes();
    },
    methods: {
        async fetchEpisodes() {
            try {
                this.loadingEpisodes = true;

                const params = {
                    podcast: this.podcast.id,
                    page_size: this.pageSize,
                    page: this.page,
                    ordering: '-id',
                };

                const { results, count } = await this.$http.get(
                    `/api/v1/podcast/episodes_settings/`,
                    {
                        params,
                    }
                );

                if (this.page > 1) {
                    this.episodes = [...this.episodes, ...results];

                    return;
                }

                this.episodes = results;
                this.episodesCount = count;
            } catch (e) {
                console.log(e);
            } finally {
                this.loadingEpisodes = false;
            }
        },
        loadmore() {
            this.page = this.page + 1;
        },
        selectEpisode(id) {
            this.selectedEpisode = id;
        },
        close() {
            this.$emit('closed');
        },
        onEpisodeAdded() {
            if (this.page === 1) {
                this.fetchEpisodes();
            }
            this.selectedEpisode = undefined;
            this.page = 1;
            this.showForm = false;
        },
    },
};
</script>

<style lang="scss" src="./PodcastEpisodesEditor.scss"></style>
